import { memo, useMemo } from 'react'
import Group from 'components/utils/Group'
import Sheet from 'components/utils/Sheet'
import AspectRatio from 'components/utils/AspectRatio'
import Image from 'components/Common/Image/Image'
import BodyText from 'LuxKit/Typography/BodyText'
import Heading from 'LuxKit/Typography/Heading'
import type { RetailStoreType } from 'constants/retailStores'
import { getRetailStoreLocation } from 'constants/retailStores'
import { useOfficeLocationContent } from 'components/Pages/AboutUsPage/OfficeLocationModal/OfficeLocationModal'

interface Props {
  storeType: RetailStoreType
}

function NavBarStoreDropdownContent(props: Props) {
  const { storeType } = props
  const { officeContentByLocation } = useOfficeLocationContent()
  const store = useMemo(
    () => officeContentByLocation[getRetailStoreLocation(storeType)],
    [officeContentByLocation, storeType],
  )

  return (
    <Group direction="vertical">
      <AspectRatio ratio="16:9">
        <Image id={store.imageId} fit="center" objectFit="cover" />
      </AspectRatio>
      <Sheet padding={16}>
        <Group direction="vertical" gap={4}>
          <Heading variant="heading6">{store.officeTitle}</Heading>
          <BodyText variant="small" colour="light-foreground-alt">{store.address}</BodyText>
        </Group>
      </Sheet>
    </Group>
  )
}

export default memo(NavBarStoreDropdownContent)
